import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
 import Navbar from './components/Navbar';
 import Footer from './components/Footer';
import Home from './pages/Home';
import Contact from './pages/Contact';
import Propos from './pages/Propos';

function App() {
  return (
    <BrowserRouter>
       <Navbar /> 
      <Routes>
        <Route path="/" element={<Home />} />
     <Route path="/contact" element={<Contact />} /> 
        <Route path="/propos" element={<Propos />} />  
      </Routes>
      <Footer /> 
    </BrowserRouter>
  );
}

export default App;


